import classNames from 'classnames'

import { useIsScrollable } from '../../hooks'

import * as styles from './ScrollContainer.module.css'

/**
 * @typedef {object} ScrollContainerProps
 *
 * @property {string} [Element]
 *
 * @property {React.ReactNode} [children]
 *
 * @property {string} [className]
 *
 * @property {string} [horizontalClassName]
 *
 * @property {string} [verticalClassName]
 */

/**
 * @param {ScrollContainerProps} props
 */
function ScrollContainer({
  Element = 'div',
  children,
  className = styles.ScrollContainer,
  horizontalClassName = styles.horizontal,
  verticalClassName = styles.vertical,
  ...elementProps
}) {
  const { isHorizontalScrollable, isVerticalScrollable, ref } =
    useIsScrollable()

  const elementClassName = classNames(className, {
    [horizontalClassName]: isHorizontalScrollable,
    [verticalClassName]: isVerticalScrollable,
  })

  return (
    <Element {...elementProps} className={elementClassName} ref={ref}>
      {children}
    </Element>
  )
}

export default ScrollContainer
